import { Box } from '@bpba/ui-components';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  title: string;
  url: string;
  show?: boolean;
};

/**
 * Componente para mostrar un enlace al final de un
 * formulario.
 * @param title - texto a mostrar en el enlace.
 * @param url -  dirección del enlace
 * @param show - indicación de si se debe mostrar el enlace.
 */
export const FormLink: FC<Props> = ({ title, url, show }) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(url);
  };

  if (!show) return <></>;

  return (
    <StyledLink width={'fit auto'} margin={'auto'} mt={'48px'} color={'primary.0'} onClick={onClick}>
      {title}
    </StyledLink>
  );
};

FormLink.defaultProps = {
  show: true,
};

const StyledLink = styled(Box)({
  ':hover': {
    cursor: 'pointer',
  },
});
